// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"ef9b7c6b","477":"ef9b7c6b","570":"2ef81caf","945":"ef9b7c6b"}[chunkId] + ".chunk.css";
};